// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__1pUwt","sprite":"style_sprite__vJAm2"};